import React  from 'react'
import logo   from "../Image/logo.png"
import logo2  from "../Image/logo2.png"
import logo3  from "../Image/applogo_enhanced.png"
import logo4  from "../Image/goglelogo_enhanced.png"


function Home() {

  return (
    <div style={{width:"100%",height:"fit-content"}}>
        <div style={{width:"100%"}}>
            <img src={logo} alt="logo" style={{width:"100%"}}/>
        </div>
        <div className='main'>
            <div className='main-title'>
                <h1>
                    For Movie Goers
                </h1>
                <p>
                    Download the Movie Grub app and skip your theater concession lines. Order your food for pickup or delivery with Movie Grub.
                </p>
                <h1>
                    Movie Grub Theaters
                </h1>
                <p>
                    Join Movie Grub and offer a pickup and delivery service for your concessionaire. Make more money from your concession business and mobilize your concession stand with Movie Grub. No more concession lines and more convenience for your theaters and movie goers, all for free.                 </p>
                <h1>
                    What is Movie Grub?
                </h1>
                <p>
                    The Movie Grub app is a mobile technology, giving moviegoers the ability to buy concession items on their smartphones.<br/> Concession lines at the cinema can be very long, crowded and take more time than moviegoers have before show time.  Crowded concession areas are good business for theatres; however, in such cases, the moviegoer may not get the seat he or she wants, miss the previews and/or the beginning of the film.  Moviegoers would solve this issue by simply choosing not to purchase any concessions. Now when you buy your movie ticket online, you can also buy your food—never stand in crowded concession lines again.<br/> Movie Grub is a free service for all theaters to use!    With Movie Grub, increase your concession sales by more than 25%.                 </p>
            </div>
            <div className='main-img'>
                <div className='img'>
                    <img src={logo2} alt="logo2" />
                </div>
                <div style={{ marginBottom:"0.9vw",fontWeight:"600",color:"#565553" }} className='download-text'>Download Now</div>
                <div className='main-div'>
                    <a href='https://apps.apple.com/in/app/movie-grub/id1620940141' target='_blank' className="img1" style={{cursor:"default"}}><img src={logo3} alt="logo" className='hover' /></a>
                    <a href='https://play.google.com/store/apps/details?id=com.MovieGrub.moviegrub&hl=en_IN' target="_blank" className="img2" style={{cursor:"default"}}><img src={logo4} alt="logo" /></a>
                    <div style={{width:"100%", textAlign:"start"}}>
                        <div className='link-login'>Click here to <a href='https://theater.moviegrub.app/login' target='_blank'>login</a> / <a href="https://theater.moviegrub.app/login" target='_blank'>sign up</a> as a theater</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Home
